<script setup lang="ts">
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'
import { PhCheck, PhX, PhWarning, PhInfo } from '@phosphor-icons/vue'
import type { ToastMessageOptions } from 'primevue/toast'

const toast = useToast()

const getIcon = (severity: string | undefined) => {
    switch (severity) {
        case 'success':
            return PhCheck
        case 'error':
            return PhX
        case 'warn':
            return PhWarning
        case 'info':
        default:
            return PhInfo
    }
}

const handleClose = (message: ToastMessageOptions) => {
    toast.remove(message)
}
</script>

<template>
    <Toast position="top-center">
        <template #message="{ message }">
            <div
                class="toast-custom"
                :class="`toast-custom--${message.severity}`">
                <div
                    class="toast-icon-container"
                    :class="`toast-icon-container--${message.severity}`">
                    <component
                        :is="getIcon(message.severity)"
                        :size="20"
                        weight="bold"
                        class="toast-icon" />
                </div>
                <span class="toast-message-text">{{ message.detail || message.summary }}</span>
                <button
                    type="button"
                    class="toast-close-button"
                    aria-label="Close"
                    @click="handleClose(message)">
                    <PhX
                        :size="16"
                        weight="bold" />
                </button>
            </div>
        </template>
    </Toast>
</template>
